import React, { useMemo } from 'react';
import ColorLegend from 'src/components/CalendarColourLegend/ColourLegend';
import Loader from '../../components/Loader';
import CalendarDivider from 'src/components/CalendarDivider/CalendarDivider';
import {
  ICalendarEvent,
  IPropertyWithState,
  IUniqueEventType,
} from 'src/pages/Calendar/types';
import BigCalendar from 'src/components/BigCalender/BigCalender';
import './calendar-content.scss';

interface CalendarContentProps {
  uniqueEventTypes: IUniqueEventType[];
  allPropertiesWithStates: IPropertyWithState[];
  loading: boolean;
  events: ICalendarEvent[];
  onSelectEvent: (event: ICalendarEvent) => void;
  minDate: Date;
  maxDate: Date;
  defaultDate: Date;
}

const CalendarContent = ({
  uniqueEventTypes,
  allPropertiesWithStates,
  loading,
  events,
  onSelectEvent,
  minDate,
  maxDate,
  defaultDate,
}: CalendarContentProps) => {
  const allItemsNotHighlighted: boolean = useMemo(() => {
    const allEventTypesDisabled: boolean = uniqueEventTypes.every(
      (eventType: IUniqueEventType) => !eventType.enabled
    );
    const allPropertiesDisabled: boolean = allPropertiesWithStates.every(
      (property: IPropertyWithState) => !property.enabled
    );

    return allEventTypesDisabled && allPropertiesDisabled;
  }, [uniqueEventTypes, allPropertiesWithStates]);

  console.log("uniqueEventTypes: ", uniqueEventTypes)
  console.log("allItemsNotHighlighted: ", allItemsNotHighlighted)

  return (
    <div className="calendar">
      <CalendarDivider variant="light" spacing="md" />
      <div className="legend-header">
        <h3 className="legend-title">Legend</h3>
        <div className="legend-hint">
          <span className="legend-hint__text">
            💡Filter events by adjusting the dates above - highlighted
            properties have events in this range.
          </span>
        </div>
      </div>
      <div className="calendar-events-container">
        {/* Event types legend. */}
        <div className="legend-container">
          <span className="color-legend-label">Event Type</span>
          <ColorLegend label="Event Types" items={uniqueEventTypes} />
        </div>
        {/* Properties legend. */}
        <div className="legend-container">
          <span className="color-legend-label">Property</span>
          <ColorLegend label="Properties" items={allPropertiesWithStates} />
        </div>
      </div>
      <CalendarDivider variant="light" spacing="lg" />
      <div className="calendar_container">
        {loading ? (
          <Loader center={true} />
        ) : (
          <BigCalendar
            events={events}
            onSelectEvent={onSelectEvent}
            minDate={minDate}
            maxDate={maxDate}
            defaultDate={defaultDate}
            allItemsNothighlighted={allItemsNotHighlighted}
          />
        )}
      </div>
    </div>
  );
};

export default CalendarContent;
